import styled from 'styled-components'
import { colors } from '@theme'
import { H2 } from '../Globals'
import { OutlineButton } from '../Button'

export const StyledHeader = styled(H2)`
  color: #27251F;
  font-size: ${({ fontSize }) => fontSize || '12px'};
  letter-spacing: 2px;
  line-height: 26px;
  padding-bottom ${({ paddingBottom }) => paddingBottom || '4px'};
  border-bottom: 1px solid ${({ dividerColor }) => dividerColor || colors.gray};
  text-transform: uppercase;
  width: 100%;
  box-sizing: border-box;
  margin: ${({ margin }) => margin || '30px 0px 20px'};
  margin-bottom ${({ marginBottom }) => marginBottom || '20px'};
  margin-top ${({ marginTop }) => marginTop || '30px'};
  color: ${({ color }) => color || 'black'};
`

export const StyledLoadMoreButton = styled(OutlineButton)`
  width: 100%;
  ${({ margin }) => margin && `margin: ${margin}`};
`
